<script>
  import { onMount } from "svelte";
  export let copy;

  let modelViewer = "";
  let open = true;
  let animationFinished = true;

  onMount(() => {
    modelViewer = document.getElementById("unit01");
  });

  function playRange() {
    let animationPause;

    modelViewer.play();
    if (open & animationFinished) {
      let CloseIconGroupe = document.getElementById("CloseIconGroupe");
      CloseIconGroupe.style.visibility = "hidden";
      openIconGroupe.style.visibility = "visible";

      let allAnimationHolders = document.getElementsByClassName("overlaysFXs");
      for (var i = 0, len = allAnimationHolders.length; i < len; i++) {
        allAnimationHolders[i].style.opacity = 0;
      }

      animationFinished = false;
      removeHotspots();
      modelViewer.currentTime = "3";
      animationPause = setTimeout(function () {
        modelViewer.pause();
        open = false;
        animationFinished = true;
      }, 1000);
    } else if (!open && animationFinished) {
      openIconGroupe.style.visibility = "hidden";
      CloseIconGroupe.style.visibility = "visible";
      animationFinished = false;
      modelViewer.currentTime = "5";
      animationPause = setTimeout(function () {
        modelViewer.pause();
        open = true;
        showHotspots();
        animationFinished = true;

        let allAnimationHolders = document.getElementsByClassName(
          "overlaysFXs"
        );
        for (var i = 0, len = allAnimationHolders.length; i < len; i++) {
          allAnimationHolders[i].style.opacity = 1;
        }
      }, 600);
    }
  }

  function removeHotspots() {
    let hotspots = document.getElementsByClassName("hotspot");
    for (var i = 0; i < hotspots.length; i++) {
      hotspots[i].style.visibility = "hidden";
    }
    log2('3dclick', 'hotspot-click - device closed');
    loggin('3dclick', 'hotspot-click - device closed');
  }

  function showHotspots() {
    let hotspots = document.getElementsByClassName("hotspot");
    for (var i = 0; i < hotspots.length; i++) {
      hotspots[i].style.visibility = "visible";
    }
    log2('3dclick', 'hotspot-click - device opened');
    loggin('3dclick', 'hotspot-click - device opened');
  }

  function hoverHandler() {
    //Share svg assets
    let Label = document.getElementById("closeLabel");
    Label.style.color = "#149ED9";
    let circleSvg = document.getElementById("circleSvg");
    circleSvg.style.stroke = "#1299d6";

    //opened svg assets
    let closeSvg01 = document.getElementById("closeSvg01");
    let closeSvg02 = document.getElementById("closeSvg02");
    closeSvg01.style.stroke = "#1299d6";
    closeSvg02.style.stroke = "#1299d6";

    closeSvg01.style.fill = "#1299d6";
    closeSvg02.style.fill = "#1299d6";

    //opened svg assets
    let openSvg01 = document.getElementById("openSvg01");
    let openSvg02 = document.getElementById("openSvg02");
    let openSvg03 = document.getElementById("openSvg03");
    openSvg01.style.stroke = "#1299d6";
    openSvg02.style.stroke = "#1299d6";
    openSvg03.style.stroke = "#1299d6";

    openSvg01.style.fill = "#1299d6";
    openSvg02.style.fill = "#1299d6";
    openSvg03.style.fill = "#1299d6";
  }

  function rollOutHandler() {
    //Share svg assets
    let Label = document.getElementById("closeLabel");
    Label.style.color = "#ffffff";
    let circleSvg = document.getElementById("circleSvg");
    circleSvg.style.stroke = "#ffffff";

    //opened svg assets
    let closeSvg01 = document.getElementById("closeSvg01");
    let closeSvg02 = document.getElementById("closeSvg02");
    closeSvg01.style.stroke = "#ffffff";
    closeSvg02.style.stroke = "#ffffff";

    closeSvg01.style.fill = "#ffffff";
    closeSvg02.style.fill = "#ffffff";

    //opened svg assets
    let openSvg01 = document.getElementById("openSvg01");
    let openSvg02 = document.getElementById("openSvg02");
    let openSvg03 = document.getElementById("openSvg03");
    openSvg01.style.stroke = "#ffffff";
    openSvg02.style.stroke = "#ffffff";
    openSvg03.style.stroke = "#ffffff";

    openSvg01.style.fill = "#ffffff";
    openSvg02.style.fill = "#ffffff";
    openSvg03.style.fill = "#ffffff";
  }
</script>

<style type="text/scss">
  .close-device {
    pointer-events: all;
    -webkit-user-select: all;
    -moz-user-select: all;
    -ms-user-select: all;
    user-select: all;

    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    .img-container {
      width: 2.3rem;
      height: 2.3rem;
    }

    p {
      margin-top: 4px;
      pointer-events: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    .close-device-normal {
      color: #ffffff;
    }
    .close-device-selected {
      color: #1299d6;
    }

    .svgNone {
      fill: none;
    }
    .svgFill {
      fill: #ffffff;
    }
    .svgStroke {
      stroke: #ffffff;
      fill: none;
      stroke-width: 5;
    }
  }
</style>

<div
  class="close-device"
  on:click={playRange}
  on:mouseenter={hoverHandler}
  on:mouseleave={rollOutHandler}>
  <div class="img-container">
    <svg
      version="1.1"
      id="Close_device_icon"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 63 63"
      style="enable-background:new 0 0 63 63;"
      xml:space="preserve">
      <g>
        <circle class="svgNone" cx="31.5" cy="31.5" r="31.5" />
        <circle id="circleSvg" class="svgStroke" cx="31.5" cy="31.5" r="29" />
      </g>

      <g id="CloseIconGroupe">
        <path
          id="closeSvg01"
          class="svgFill"
          d="M42.9,44.5H12.8v-2.3h28.1l4.2-28.4l2.3,0.3L42.9,44.5z" />
        <path
          id="closeSvg02"
          class="svgFill"
          d="M17.3,32l-1.9-4.3l-1.8,0.9l3.2,7.4l7.2-3.6l-0.8-1.8l-4.2,2l0.9-2.6c3-8.2,11.8-12.5,19.6-9.7
          l1.4,0.5l0.7-1.9l-1.4-0.5c-8.9-3.2-18.8,1.7-22.1,10.9L17.3,32z" />
      </g>

      <g id="openIconGroupe" style="visibility:hidden;">
        <path
          id="openSvg01"
          class="svgFill"
          d="M45.9,44.5H15.8v-2.3h30.1V44.5z" />
        <path
          id="openSvg02"
          class="svgFill"
          d="M46.2,42.3L16,38.5l0.2-2.3l30.3,3.7L46.2,42.3z" />
        <path
          id="openSvg03"
          class="svgFill"
          d="M38.2,17.9c-9.7-1.8-18.9,4.3-20.6,13.6l-0.3,1.4l2,0.4l0.3-1.4c1.5-8.2,9.7-13.6,18.2-12 l2.7,0.5l-3.9,2.5l1.2,1.6l6.7-4.4l-4.7-6.5l-1.7,1.1l2.7,3.8L38.2,17.9z" />
      </g>
    </svg>
    <!-- <img id="closeSVG" class="img" src={open ? image : imageSelected} alt="close-device" /> -->
  </div>
  <p
    id="closeLabel"
    class={open ? 'close-device-normal' : 'close-device-selected'}>
    {@html open ? copy.close_device : copy.open_device}
  </p>
</div>
